import ModalBody from 'LuxKit/Modal/ModalBody'
import ModalContent from 'LuxKit/Modal/ModalContent'
import ModalHeader from 'LuxKit/Modal/ModalHeader'
import { useIntl } from 'react-intl'
import StripeOffsessionCardUpdate from 'components/Vendor/StripeOffsessionCardUpdate'

interface Props {
  onBack: () => void
  item: App.MemberSubscriptionItem
  onUpdatePaymentMethodSuccess?: () => void
  onUpdatePaymentMethodFailure?: () => void
}

function LuxPlusManageAccountModalUpdatePaymentMethod(props: Props) {
  const intl = useIntl()
  const { onBack, item, onUpdatePaymentMethodSuccess, onUpdatePaymentMethodFailure } = props

  return <>
    <ModalHeader
      title={intl.formatMessage({
        id: 'flRO2IippcTvV0NZEaIm',
        defaultMessage: 'Update payment method',
        description: 'Modal header title for updating LuxPlus subscription payment method',
      })}
      onBackButtonClick={onBack}
    />
    <ModalBody>
      <ModalContent>
        <StripeOffsessionCardUpdate
          purpose="lux_plus"
          purposeId={item.id}
          onSuccess={onUpdatePaymentMethodSuccess}
          onFailure={onUpdatePaymentMethodFailure}
        />
      </ModalContent>
    </ModalBody>
  </>
}

export default LuxPlusManageAccountModalUpdatePaymentMethod
